import React, { useEffect, useState } from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { Redirect } from 'react-router-dom';
import { Loading } from 'react-style-guide';
import SortDetailGridV2GamesApi from './SortDetailGridV2GamesApi';
import ErrorStatus from '../../common/components/ErrorStatus';
import bedev1Services from '../../common/services/bedev1Services';
import { CommonGameSorts } from '../../common/constants/translationConstants';
import { TPageType, TOmniRecommendationSort } from '../../common/types/bedev1Types';
import gameCarouselTranslationConfig from '../../../../js/react/gameCarousel/translation.config';

export const SortDetailV2GamesApi = ({
  sortName,
  translate
}: { sortName: string } & WithTranslationsProps): JSX.Element => {
  const [sort, setSort] = useState<TOmniRecommendationSort | undefined>(undefined);
  const [redirect, setRedirect] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const fetchRecommendations = async () => {
    setError(false);
    setSort(undefined);
    try {
      const omniRecommendations = await bedev1Services.getOmniRecommendations(TPageType.Home);
      const selectedSort = omniRecommendations.Sorts.find(sortItem => sortItem.Topic === sortName);
      if (selectedSort === undefined) {
        setRedirect(true);
      } else {
        setSort(selectedSort);
      }
    } catch {
      setError(true);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchRecommendations();
  }, [sortName]);

  // Error in API calls
  if (error) {
    return (
      <div className='game-sort-detail-container'>
        <h3>{translate(CommonGameSorts.LabelGames)}</h3>
        <div className='game-sort-detail'>
          <ErrorStatus
            errorMessage={translate(CommonGameSorts.LabelApiError)}
            onRefresh={fetchRecommendations}
          />
        </div>
      </div>
    );
  }

  // Redirect if recommendation cannot be found
  if (redirect) {
    return <Redirect to='/' />;
  }

  // Recommendations are loaded
  if (sort) {
    return (
      <div className='game-sort-detail-container'>
        <h3>{sortName}</h3>
        <SortDetailGridV2GamesApi sort={sort} translate={translate} />
      </div>
    );
  }

  return <Loading />;
};

export default withTranslations(SortDetailV2GamesApi, gameCarouselTranslationConfig);
